<template>
  <admin-page-shell
    :title="$t('frontend_groovemail_admin_alerts')"
    :subtitle="$t('frontend_groovemail_admin_configure_settings')"
  >
    <template slot="tabs">
      <gd-tabs
        :tabs="tabs"
        :currentTab="currentTab"
        :disableNotCompleted="false"
        @onClick="handleTabChange"
      />
    </template>
    <component
      :is="currentTab"
      @showLoader="showLoader"
      @hideLoader="hideLoader"
    />
  </admin-page-shell>
</template>

<script>
import { mapActions } from "vuex";
import AlertSetting from './alert-setting.vue';
import AlertListing from './alert-listing.vue';
import AdminPageShell from '../AdminPageShell.vue';

export default {
  middleware: 'auth',

  metaInfo() {
    return { title: this.$t('frontend_groovemail_admin_settings_title') };
  },

  data() {
    return {
      currentTab: 'alertListing',
    };
  },

  components: {
    AdminPageShell,
    alertSetting: AlertSetting,
    alertListing: AlertListing,
  },

  methods: {
    ...mapActions('loader', ['LOADING']),

    // show loader
    showLoader() {
      this.LOADING(true);
    },

    // hide loader
    hideLoader (){
      this.LOADING(false);
    },
    
    /**
     * Used to handle tab change based on setting type.
     * @param {string} newTab changed tab.
     */
    handleTabChange(newTab) {
      this.currentTab = newTab;
    },
  },

  computed: {
    /**
     * Returns tabs data for alert settings.
     * @return {array} tab data.
     */
    tabs() {
      return [
        {
          title: `<span class="text-sm leads-field mr-3"></i>&nbsp;${this.$t(
            'frontend_groovemail_admin_alert_listing'
          )}<span>`,
          value: 'alertListing',
        },
        {
          title: `<span class="text-sm leads-field mr-3"></i>&nbsp;${this.$t(
            'frontend_groovemail_admin_alert_setting'
          )}<span>`,
          value: 'alertSetting',
        },
      ];
    },

    /**
     * Returns the style for tabs.
     * @return {string} tabs styling.
     */
    mainTabClass() {
      return 'pb-2 gs-default-tabs-item';
    },
  },
};
</script>
